import PropTypes from 'prop-types';
import React from 'react';

const VideoPlayer = ({ src, controls, autoPlay, loop, muted }) => {
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      className="rounded-lg focus:ring-2 outline-none"
      src={src}
      controls={controls}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
    />
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  controls: true,
  autoPlay: false,
  loop: false,
  muted: false,
};

export default VideoPlayer;
